// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  align-items: center;
}
ion-row ion-col {
  width: -moz-fit-content;
  width: fit-content;
}
ion-row ion-select {
  --padding-bottom: 5px;
  --padding-top: 5px;
}
ion-row img {
  height: 25px;
  width: 25px;
}

::ng-deep .mc-wider-popover {
  --width: auto !important;
  --max-widh: auto;
}

.letra {
  color: var(--a-7-aeb-1, #a7aeb1);
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.175px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvdW50cnktc2VsZWN0b3IuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxtQkFBQTtBQUNGO0FBQUU7RUFDRSx1QkFBQTtFQUFBLGtCQUFBO0FBRUo7QUFDRTtFQUNFLHFCQUFBO0VBQ0Esa0JBQUE7QUFDSjtBQUVFO0VBQ0UsWUFBQTtFQUNBLFdBQUE7QUFBSjs7QUFHQTtFQUNFLHdCQUFBO0VBQ0EsZ0JBQUE7QUFBRjs7QUFJQTtFQUNFLGdDQUFBO0VBQ0EsaUJBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7RUFDQSxnQkFBQTtFQUNBLGlCQUFBO0VBQ0EsdUJBQUE7QUFERiIsImZpbGUiOiJjb3VudHJ5LXNlbGVjdG9yLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaW9uLXJvdyB7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGlvbi1jb2wge1xuICAgIHdpZHRoOiBmaXQtY29udGVudDtcbiAgfVxuXG4gIGlvbi1zZWxlY3Qge1xuICAgIC0tcGFkZGluZy1ib3R0b206IDVweDtcbiAgICAtLXBhZGRpbmctdG9wOiA1cHg7XG4gIH1cblxuICBpbWcge1xuICAgIGhlaWdodDogMjVweDtcbiAgICB3aWR0aDogMjVweDtcbiAgfVxufVxuOjpuZy1kZWVwIC5tYy13aWRlci1wb3BvdmVyIHtcbiAgLS13aWR0aDogYXV0byAhaW1wb3J0YW50O1xuICAtLW1heC13aWRoOiBhdXRvO1xuXG59XG5cbi5sZXRyYSB7XG4gIGNvbG9yOiB2YXIoLS1hLTctYWViLTEsICNhN2FlYjEpO1xuICBmb250LWZhbWlseTogTGF0bztcbiAgZm9udC1zaXplOiAxNHB4O1xuICBmb250LXN0eWxlOiBub3JtYWw7XG4gIGZvbnQtd2VpZ2h0OiA0MDA7XG4gIGxpbmUtaGVpZ2h0OiAxNDAlO1xuICBsZXR0ZXItc3BhY2luZzogMC4xNzVweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/shared/country-selector/country-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EACE,uBAAA;EAAA,kBAAA;AAEJ;AACE;EACE,qBAAA;EACA,kBAAA;AACJ;AAEE;EACE,YAAA;EACA,WAAA;AAAJ;;AAGA;EACE,wBAAA;EACA,gBAAA;AAAF;;AAIA;EACE,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AADF;AAEA,wrCAAwrC","sourcesContent":["ion-row {\n  align-items: center;\n  ion-col {\n    width: fit-content;\n  }\n\n  ion-select {\n    --padding-bottom: 5px;\n    --padding-top: 5px;\n  }\n\n  img {\n    height: 25px;\n    width: 25px;\n  }\n}\n::ng-deep .mc-wider-popover {\n  --width: auto !important;\n  --max-widh: auto;\n\n}\n\n.letra {\n  color: var(--a-7-aeb-1, #a7aeb1);\n  font-family: Lato;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n  letter-spacing: 0.175px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
